<template>
  <div>
    <div id="myOrder" v-if="showView">
      <div class="small-tip" v-if="contractList.length > 0 && showTip">
        <span>
          <i class="es-icon-warning" style="margin-right: 10px"></i>
          {{ $t('通知：您有一个原购买合同解约协议待确认。') }}{{ contractList[0].modifyDate | formatUtc }}
        </span>
        <es-button type="text" @click="getPdfUrl(item)">{{ $t('查看详情') }}</es-button>
      </div>
      <div class="small-tip" v-if="contractBills.length > 0 && showBillTip">
        <span>
          <i class="es-icon-warning" style="margin-right: 10px"></i>
          {{ $t('通知：您有一个结算单待确认。') }}{{ contractBills[0].modifyDate | formatUtc }}
        </span>
        <es-button type="text" @click="getBillPdfUrl">{{ $t('查看详情') }}</es-button>
      </div>
      <subTitle
        :title="$t(`我的订单`)"
        :tip="$t(`提示：除企业管理员、计费管理员可见所有订单外，其他身份用户仅可见自己下单的订单。`)"></subTitle>
      <div class="main">
        <ul class="tabs" :key="activeName">
          <li v-for="(item, index) in tabList" :key="index" :class="activeName == item.val ? 'active' : ''" @click="changeActive(item.val)">
            {{ item.name }}
          </li>
        </ul>
        <div class="search-section">
          <div>
            <span>{{ $t('下单时间：') }}</span>
            <es-date-picker
              v-model="search.time"
              class="margin-left-10"
              type="daterange"
              :range-separator="$t(`至`)"
              :start-placeholder="$t(`开始日期`)"
              :end-placeholder="$t(`结束日期`)"
              value-format="timestamp"></es-date-picker>
          </div>
          <div v-if="!isPartner">
            <span>{{ $t('订购产品：') }}</span>
            <es-select v-model="search.proId" class="margin-left-10" :placeholder="$t(`请选择`)">
              <es-option v-for="(item, index) in proList" :key="index" :label="item.commodityName" :value="item.commodityId"></es-option>
            </es-select>
          </div>
          <div>
            <span>{{ $t('订单状态：') }}</span>
            <es-select v-model="search.status" class="margin-left-10" :placeholder="$t(`请选择`)">
              <es-option v-for="item in orderStatus" :key="item.val" :label="item.label" :value="item.val"></es-option>
            </es-select>
          </div>
          <div v-if="activeName === 0 && !isPartner">
            <span>{{ $t('特殊订单类型：') }}</span>
            <es-select v-model="search.productTypes" class="margin-left-10" :placeholder="$t(`请选择`)">
              <es-option :label="$t(`转售订单`)" value="0"></es-option>
              <es-option :label="$t(`授权订单`)" value="1"></es-option>
              <es-option :label="$t(`后付费订单`)" value="3"></es-option>
            </es-select>
          </div>
          <div v-if="activeName === 0">
            <span>{{ $t('支付状态：') }}</span>
            <es-select v-model="search.payStatus" class="margin-left-10" :placeholder="$t(`请选择`)">
              <es-option v-for="item in payStatusList" :key="item.val" :label="item.label" :value="item.val"></es-option>
            </es-select>
          </div>
          <div v-if="activeName === 0">
            <span>{{ $t('合同编号：') }}</span>
            <es-input v-model="search.contractId" class="margin-left-10 width-auto" :placeholder="$t(`请输入`)" />
          </div>
          <div v-if="activeName === 0">
            <span>{{ $t('订单编号：') }}</span>
            <es-input v-model="search.showId" class="margin-left-10 width-auto" :placeholder="$t(`请输入`)" />
          </div>
          <div class="allNumber">
            <es-button @click="searchList()" type="primary">{{ $t('查询') }}</es-button>
            <es-button variant="outline" @click="clear()">{{ $t('清空') }}</es-button>
          </div>
        </div>
        <divided />
        <div id="my-order" v-if="activeName !== 1">
          <div
            class="table-card"
            v-for="(item, index) in orderList"
            :key="index"
            :class="item.showState === '已失效' ? 'table-diabled' : ''">
            <div class="table-card-header">
              <div>
                <div class="table-card-header-name">
                  <es-checkbox
                    v-model="checkList"
                    :label="item"
                    v-show="showCheckBox && showInvoiceButton(item)"
                    class="table-card-header-checkbox">
                    &nbsp;
                  </es-checkbox>
                  {{ item.commodityName }}
                  <i v-if="item.showType" class="order-type" style="padding: 0 10px">{{ item.showType }}</i>
                  <es-popover placement="right" width="450" trigger="hover">
                    <div class="pop">
                      <es-row class="detailTip">
                        {{
                          $t('{slot1} 于 {slot2} 授权此订单', {
                            slot1: item.authGidName,
                            slot2: item.authTime,
                          })
                        }}
                      </es-row>
                    </div>
                    <span v-show="activeName === 2 || activeName === 3" @mouseover="orderAuthQuery(item)" slot="reference" class="authTip">
                      {{ $t('被授权订单') }}
                    </span>
                  </es-popover>
                </div>
                <div>{{ $t('订单编号：') }}{{ item.showId }}</div>
              </div>
              <div>
                <div v-if="activeName == 0 && !isResaleSubOrder(item)">{{ $t('订单金额：') }}{{ item.price.toFixed(2) }}{{ $t('元') }}</div>
                <div v-show="item.contractId && !isResaleSubOrder(item)">{{ $t('合同编号：') }}{{ item.contractId }}</div>
              </div>

              <div>
                <div v-if="!item.isUnLimitNum && activeName === 0 && !isResaleSubOrder(item)">
                  <span>
                    {{ $t('单价：')
                    }}{{
                      item.saleType == 2 ? $t('分开计价详单') : parseFloat((item.price / item.totalNum).toFixed(4)) + $t('元/') + item.units
                    }}
                    <es-popover width="320" placement="right" trigger="click">
                      <div class="pop">
                        <tree :initData="treeData" v-if="treeData.length"></tree>
                        <div v-else>{{ $t('暂无数据') }}</div>
                      </div>
                      <i class="es-icon-question" v-show="item.saleType == 2" slot="reference" @click="getDetail(item)"></i>
                    </es-popover>
                  </span>
                </div>
                <div>{{ $t('下单时间：') }}{{ item.createTime | formatUtc }}</div>
              </div>
              <div>
                <div
                  style="font-weight: normal"
                  :class="{
                    /* i18n-ignore */
                    ready: item.showState == '待生效',
                    unsuccess: item.showState == '已失效',
                    success: item.showState == '生效中' || item.showState == '交易成功',
                    stop: item.showState == '已停用',
                  }">
                  <!-- i18n-ignore  -->
                  <i class="es-icon-circle-check" v-if="item.showState != '待生效' && item.showState != '已停用'"></i>
                  <!-- i18n-ignore  -->
                  <i class="icon-stop" v-else-if="item.showState == '已停用'"></i>
                  <!-- i18n-ignore  -->
                  <i class="readyIcon" v-if="item.showState == '待生效'"></i>
                  {{ item.showState }}
                </div>
              </div>
            </div>
            <div class="table">
              <es-row class="table-title">
                <es-col :span="3">{{ $t('产品规格数量') }}</es-col>
                <es-col :span="5">{{ $t('有效时间') }}</es-col>
                <es-col v-if="isAuthedOrder" :span="2">{{ $t('授权方式') }}</es-col>
                <es-col v-if="item?.authType === 2 && isAuthedOrder && item.authConsumeInfo" :span="2">{{ $t('授权量') }}</es-col>
                <es-col v-if="item?.authType === 2 && isAuthedOrder && item.authConsumeInfo" :span="2">{{ $t('剩余量') }}</es-col>
                <es-col v-if="item.authType !== 2" :span="2">
                  {{ isResaleMainOrder(item) ? $t('已转售量') : $t('已使用量') }}
                </es-col>
                <es-col v-if="item.lockNum > 0 || item.authConsumeInfo?.lockInfo?.num !== 0" :span="2">{{ $t('预扣用量') }}</es-col>
                <es-col v-if="item.authType !== 2" :span="3">{{ isResaleMainOrder(item) ? $t('剩余可转售量') : $t('当前余量') }}</es-col>
                <es-col :span="3">{{ $t('付款状态') }}</es-col>
                <es-col :span="4" class="operation-buttons">{{ $t('操作') }}</es-col>
              </es-row>
              <es-row class="table-main">
                <es-col :span="3">{{ item.isUnLimitNum ? $t('无限') : item.totalNum + getShowUnit(item) }}</es-col>
                <es-col :span="5">
                  <es-button v-if="item.webParameter.canSetTimeOnline === 1" type="text" @click="getHistoryUsed(item)">
                    {{ $t('配置上线时间') }}
                  </es-button>
                  <span v-else>{{ item.startToEnd }}</span>
                </es-col>
                <es-col v-if="isAuthedOrder" :span="2">
                  {{ item.authType === 2 ? $t('配额') : $t('共享') }}
                </es-col>
                <es-col v-if="showAuthConsumeInfo(item)" :span="2">
                  {{ `${item.authConsumeInfo?.totalInfo?.num || '0'}${item.authConsumeInfo?.totalInfo?.unit || ''}` }}
                </es-col>
                <es-col v-if="showAuthConsumeInfo(item)" :span="2">
                  <span :style="{ color: item.authConsumeInfo?.marginInfo?.num === 0 ? 'red' : '#4b4b4bff' }">
                    {{ `${item.authConsumeInfo?.marginInfo?.num || '0'}${item.authConsumeInfo?.marginInfo?.unit || ''}` }}
                  </span>
                </es-col>
                <es-col v-if="item.authType !== 2" :span="2">
                  <span v-if="item.status == 0 || (isProductOrder(item) && item.productType !== 11)">--</span>
                  <span v-else-if="item.units === 'G'">{{ showDataUnit(item.used, 'floor', item) }}</span>
                  <span v-else>{{ getShowPrice(item, 'used', 'KB', 1) + getShowUnit(item, 'MB') }}</span>
                </es-col>
                <es-col v-if="item.lockNum > 0 || item.authConsumeInfo?.lockInfo?.num !== 0" :span="2">
                  <span v-if="showAuthConsumeInfo(item)">
                    {{ `${item.authConsumeInfo?.lockInfo?.num || '0'}${item.authConsumeInfo?.lockInfo?.unit || ''}` }}
                  </span>
                  <span v-else-if="item.units === 'G'">{{ showDataUnit(item.lockNum, 'floor', item) }}</span>
                  <span v-else>{{ getShowPrice(item, 'lockNum', 'MB') + getShowUnit(item, 'MB') }}</span>
                </es-col>
                <es-col v-if="item.authType !== 2" :span="3">
                  <span v-if="item.status == 0 || (isProductOrder(item) && item.productType !== 11)">--</span>
                  <span v-else-if="item.isUnLimitNum">{{ $t('无限') }}</span>
                  <span v-else-if="item.units === 'G'">{{ showDataUnit(item.margin, 'ceil', item) }}</span>
                  <span v-else>{{ getShowPrice(item, 'margin', 'G', 2) + getShowUnit(item, 'MB') }}</span>
                </es-col>
                <es-col :span="3">
                  {{
                    activeName === 2 || activeName === 3 || isResaleSubOrder(item)
                      ? '--'
                      : item.payStatus == 0
                      ? $t('待支付')
                      : item.payStatus == 1
                      ? $t('已支付')
                      : item.payStatus == 2
                      ? $t('付款中')
                      : item.payStatus == 3
                      ? $t('未支付')
                      : ''
                  }}
                  &nbsp;
                </es-col>
                <es-col :span="4" class="operation-buttons">
                  <!-- 保留常用按钮直接显示 -->
                  <es-button type="text" @click="downLoad(item)" v-if="item.webParameter.showLicenseDownloadFlag === 1">
                    {{ $t('下载License') }}
                  </es-button>
                  <es-popover
                    v-if="item.webParameter.showLicenseDownloadFlag"
                    placement="bottom"
                    width="200"
                    trigger="hover"
                    :content="$t(`下载license授权文件后请在指定的系统中导入使用`)">
                    <i class="es-icon-question" slot="reference" style="margin-right: 5px"></i>
                  </es-popover>

                  <es-button @click="jumpDetail(item, $t('在线支付'))" v-if="showPayButton(item)" type="text">
                    {{ $t('在线支付') }}
                  </es-button>

                  <es-button type="text" @click="jumpDetail(item, $t('我要开票'))" v-if="showInvoiceButton(item)">
                    {{ $t('我要开票') }}
                  </es-button>

                  <!-- 更多操作下拉菜单 -->
                  <es-dropdown v-if="hasMoreOperations(item)" @command="handleCommand($event, item)">
                    <es-button type="text">
                      {{ $t('更多操作') }}
                      <i class="es-icon-arrow-down el-icon--right"></i>
                    </es-button>
                    <es-dropdown-menu slot="dropdown">
                      <es-dropdown-item
                        :command="'operateResale'"
                        v-if="item.webParameter.canOperateResale !== 0 && userInfo.isAdmin"
                        :disabled="item.webParameter.canOperateResale === 2">
                        {{ $t('操作转售') }}
                      </es-dropdown-item>

                      <es-dropdown-item
                        :command="'viewBill'"
                        v-if="item.webParameter.showBillDetail !== 0"
                        :disabled="item.webParameter.showBillDetail === 2">
                        {{ $t('查看账单') }}
                      </es-dropdown-item>

                      <es-dropdown-item
                        :command="'resaleRecord'"
                        v-if="item.webParameter.isShowResaleHis === 1 && activeName == 0 && userInfo.isAdmin">
                        {{ $t('转售记录') }}
                      </es-dropdown-item>

                      <es-dropdown-item :command="'viewInvoice'" v-if="item.webParameter.isShowElecInvoiceFlag">
                        {{ $t('查看发票') }}
                      </es-dropdown-item>

                      <es-dropdown-item :command="'openChildService'" v-if="item.webParameter.showChildServiceOpenFlag === 1">
                        {{ $t('开通新的子服务') }}
                      </es-dropdown-item>

                      <es-dropdown-item :command="'buyAgain'" v-if="showBuyButton(item)">
                        {{ $t('再次购买') }}
                      </es-dropdown-item>

                      <es-dropdown-item
                        :command="'viewSettlementHistory'"
                        v-if="item.webParameter.showSettlementRecordFlag !== 0"
                        :disabled="item.volumesList && item.volumesList.length == 0">
                        {{ $t('查看历史结算') }}
                      </es-dropdown-item>

                      <es-dropdown-item :command="'authorize'" v-if="item.webParameter.isShowAuth === 1">
                        {{ $t('授权') }}
                      </es-dropdown-item>

                      <es-dropdown-item :command="'authRecord'" v-if="item.webParameter.isAuthOrder === 1">
                        {{ $t('授权记录') }}
                      </es-dropdown-item>

                      <es-dropdown-item :command="'logistics'" v-if="item.webParameter.isDeliver === 1">
                        {{ $t('物流信息') }}
                      </es-dropdown-item>
                    </es-dropdown-menu>
                  </es-dropdown>
                </es-col>
              </es-row>
            </div>
          </div>

          <es-row class="noData" v-show="orderList.length === 0" style="height: 200px">
            <es-empty
              style="margin: 25px; color: #999; line-height: 40px"
              :description="$t(`暂无更多数据`)"
              image="data:image/png;base64,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"
              :image-size="64"></es-empty>
          </es-row>

          <div class="footer" v-if="orderList.length > 0">
            <div>
              <div>
                <es-button class="marginLeft0" @click="combinedInvoice()" type="primary">{{ text }}</es-button>
                <es-button variant="outline" @click="showCheckBox = false" v-show="showCheckBox">{{ $t('取消') }}</es-button>
              </div>
              <div>
                <es-pagination
                  @current-change="currentChange"
                  :current-page.sync="currentPage"
                  layout="prev, pager, next, jumper"
                  :total="allNumber"></es-pagination>
              </div>
            </div>
          </div>
        </div>
        <my-present ref="myPresent" v-if="activeName === 1" :search="search" :currentPage="currentPage"></my-present>
      </div>
    </div>

    <es-dialog :visible.sync="pdfVisible" width="1060px" v-loading="RescindContractStatus" :esign-loading-text="$t(`拼命处理中`)">
      <div class="protocol" :esign-loading-text="$t(`拼命加载中`)" esign-loading-spinner="es-icon-loading">
        <pdf v-if="protocol" :url="protocol"></pdf>
      </div>
      <div class="confirm-bill-confirm">
        <div>
          <es-button type="primary" @click="setAccountAffirmRescindContract(1)" style="margin: 0 auto">
            {{ $t('我已阅读并同意') }}
          </es-button>
        </div>
        <div>
          <span @click="setAccountAffirmRescindContract(0)">{{ $t('不想解约') }}</span>
        </div>
      </div>
    </es-dialog>
    <!-- 结算单预览 -->

    <es-dialog :visible.sync="billPdfVisible" width="1060px">
      <div class="protocol" :esign-loading-text="$t(`拼命加载中`)" esign-loading-spinner="es-icon-loading">
        <pdf :compId="2" v-if="billProtocol" :url="billProtocol"></pdf>
      </div>
      <div class="confirm-bill-confirm">
        <div>
          <es-button type="primary" @click="accountAffirmTerminationContract" style="margin: 0 auto">
            {{ $t('同意并下载') }}
          </es-button>
        </div>
      </div>
    </es-dialog>

    <es-dialog :visible.sync="dialogVisible">
      <div slot="title" class="dialog-title">
        {{ $t('提示') }}
        <span v-show="historyProductType === 10">{{ $t('“实际消费金额”包含您已转售的量') }}</span>
      </div>
      <es-table :data="tableData" style="width: 100%">
        <es-table-column prop="startToEnd" :label="$t(`结算周期`)" width="180"></es-table-column>
        <es-table-column prop="costMoney" :label="$t(`消费金额(元)`)" width="180"></es-table-column>
        <es-table-column prop="hasPay" :label="$t(`已支付(元)`)"></es-table-column>
        <es-table-column prop="noPay" :label="$t(`未支付(元)`)"></es-table-column>
      </es-table>
    </es-dialog>

    <es-dialog :title="$t(`配置生效时间`)" class="changeTime" :visible.sync="changeTimeDialog" width="500px" border>
      <es-alert :closable="false" show-icon type="warning">
        {{ $t('配置生效时间后，商品套餐有效期不可更改或延期！若涉及接口对接等前置流程，建议系统对接完成后再配置生效') }}
      </es-alert>
      <div class="confirm-time">
        <es-radio v-model="autoRenewal" :label="false">
          <span style="width: 100px">{{ $t('指定时间：') }}</span>
          <es-date-picker
            v-model="useTime"
            type="date"
            unlink-panels
            :picker-options="pickerOptions"
            value-format="timestamp"
            style="margin-right: 10px"></es-date-picker>
          <span>{{ $t('开始生效') }}</span>
        </es-radio>
      </div>
      <div class="confirm-time" v-show="haveOrders && lastEndTime">
        <es-radio v-model="autoRenewal" :label="true">{{ $t('原订单结束后自动延续') }}</es-radio>
      </div>

      <span slot="footer" style="border-top: 1px solid #e4e4e4">
        <es-button type="primary" :disabled="disabledBool" @click="effectiveOrder">{{ $t('确定') }}</es-button>
      </span>
    </es-dialog>

    <es-dialog :title="commodityName + $t('项开通')" :visible.sync="openServerDialog" class="openServer" width="560px">
      <treeTable
        :tableData="openServerData"
        @changeCheckList="changeCheckList"
        :showCheckBox="showOpenServerCheckBox"
        hoverProp="tagName"></treeTable>
      <span slot="footer">
        <es-button variant="outline" @click="openServerDialog = false" v-if="step == 1">{{ $t('取消') }}</es-button>
        <es-button variant="outline" @click="PreviousStep" v-if="step == 2">{{ $t('上一步') }}</es-button>
        <es-button type="primary" @click="nextStep" v-if="step == 1">{{ $t('开通服务项') }}</es-button>
        <es-button type="primary" @click="openChilds" v-if="step == 2">{{ $t('确定开通') }}</es-button>
      </span>
    </es-dialog>

    <div style="width: 100%; height: 100%" class="myorder-loading" v-if="!showView" v-loading="!showView"></div>
  </div>
</template>
<script>
import { $t } from '@/locales'

/* eslint-disable no-magic-numbers */

import axios from 'axios'
import { formatUtc, getShowPrice, getShowUnit, showDataUnit, debounce, getTimingData } from '@/util.js'
import { mapState } from 'vuex'
import treeTable from '../../components/treeTable'
import tree from '../../components/tree'
import pdf from '../../components/myVuePdf'
import subTitle from '@/components/subTitle'
import divided from '../../components/divided'
import tsignData from '@tsign/tsigndata-sdk-js'
import myPresent from './MyPresent.vue'

const debounceTime = 2000
export default {
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      isPartner: state => state.isPartner,
      isOrg: state => state.isOrg,
    }),
    openServerData() {
      return this.step === 1 ? this.basicOpenServerData : this.checkOpenServerData
    },
    showOpenServerCheckBox() {
      return this.step === 1
    },
    text() {
      return this.showCheckBox ? $t('确定合并开票') : $t('合并开票')
    },
    pickerOptions() {
      const dayTimeStamp = 1000 * 60 * 60 * 24

      return {
        disabledDate(time) {
          return time.getTime() < Date.now() - dayTimeStamp
        },
      }
    },
    // 被授权订单
    isAuthedOrder() {
      return [2, 3].includes(this.activeName)
    },
  },
  components: {
    treeTable,
    tree,
    subTitle,
    pdf,
    divided,
    myPresent,
  },
  data() {
    return {
      ouid: '',
      disabledBool: false, // 按钮是否禁用
      logisticInfo: [],
      getShowPrice,
      showDataUnit,
      historyProductType: '',
      showTip: false,
      RescindContractStatus: false,
      // 配置上线时间需求
      useTime: '',
      contractList: [],
      pdfVisible: false,
      protocol: '',
      changeTimeDialog: false,
      autoRenewal: false,
      haveOrders: false,
      lastEndTime: '',
      used: '',
      chooseOrderId: '',
      commodityName: '',
      treeData: [],
      step: 1, // 当前步骤
      basicOpenServerData: [],
      checkOpenServerData: [],
      orderId: '',
      openServerDialog: false, // 子服务项目开通
      showAuthList: false,
      getShowUnit,
      commodityList: [],
      showCheckBox: false,
      checkList: [],
      activeName: this.$route.name === 'MyOrder' ? 0 : 2, // MyOrder 显示正常订单 AuthOrder 显示 授权订单
      orderType: this.$route.name, // MyOrder 显示正常订单 AuthOrder 显示 授权订单
      search: {
        status: this.$route.query.activeState ? Number(this.$route.query.activeState) : '',
        time: [],
        proId: '',
        productTypes: '',
        isAuthOrder: false,
        payStatus: '',
        contractId: '', // 合同编号
        showId: '', // 订单编号
      },
      allNumber: 0,
      proList: {},
      orderList: [],
      detailInfo: {},
      currentPage: 1,
      dialogVisible: false,
      tableData: [],
      contractBills: [], // 结算单
      billPdfVisible: false,
      billProtocol: '',
      showBillTip: false,
      billcontractId: '', // 结算单返回合同ID
      taskResult: [],
      canShowNextDialog: true,
      priceAdjusting: false, // 订单是否改价中

      tabList: [
        {
          name: $t('普通订单'),
          val: 0,
        },
        {
          name: $t('其他订单'),
          val: 1,
        },
      ],

      orderStatus: [
        // 订单状态
        {
          label: $t('已失效'),
          val: -1,
        },
        {
          label: $t('待生效'),
          val: 0,
        },
        {
          label: $t('生效中'),
          val: 1,
        },
        {
          label: $t('已停用'),
          val: 3,
        },
        {
          label: $t('已终止'),
          val: 7,
        },
        {
          label: $t('冻结中'),
          val: 8,
        },
      ],

      payStatusList: [
        {
          label: $t('未支付'),
          val: 0,
        },
        {
          label: $t('已支付'),
          val: 1,
        },
        {
          label: $t('支付中'),
          val: 2,
        },
      ],

      getInTime: Date.now(),
      firstReqTime: null,
      showView: true,
    }
  },
  methods: {
    // 配额信息
    showAuthConsumeInfo(item) {
      return item.authType === 2 && this.isAuthedOrder && item.authConsumeInfo
    },
    async getTab() {
      const showAuthList = await this.getAuthList()
      const showAuthOtherList = await this.getAuthOtherList()
      if (showAuthList & !this.isPartner) {
        this.tabList.push({
          name: $t('被授权订单(普通)'),
          val: 2,
        })
      }
      if (showAuthOtherList & !this.isPartner) {
        this.tabList.push({
          name: $t('被授权订单(其他)'),
          val: 3,
        })
      }
    },
    getAuthList() {
      return new Promise((resolve, reject) => {
        const data = {
          currentPage: 1,
        }
        this.$ajax(this.$url.getAuthorizedOrderList(), data).then(res => {
          resolve(res.data.length > 0)
        })
      })
    },
    getAuthOtherList() {
      return new Promise((resolve, reject) => {
        const data = {
          currentPage: 1,
          orderType: 1,
        }
        this.$ajax(this.$url.getAuthorizedOrderList(), data).then(res => {
          resolve(res.data.length > 0)
        })
      })
    },
    // 获取历史用量数据
    async getHistoryUsed({ saleSchemaId, productId, id }) {
      this.changeTimeDialog = true
      // 重置属性
      this.useTime = ''
      this.autoRenewal = false
      this.chooseOrderId = id
      const data = {
        saleSchemaId,
        productId,
      }
      const getHistoryRes = await this.$ajax(this.$url.getHistoryUsed(), data)
      this.haveOrders = getHistoryRes.data.haveOrders
      this.lastEndTime = getHistoryRes.data.lastEndTime
      this.used = getHistoryRes.data.used
    },
    effectiveOrder() {
      this.disabledBool = true

      this.$confirm('', $t('订单生效时间配置后不可更改或延期，确认配置？'), {
        confirmButtonText: $t('确定'),
        cancelButtonText: $t('暂不配置'),
        type: 'warning',
        customClass: 'effective-order',
        closeOnClickModal: false,
      })
        .then(() => {
          const data = {
            orderId: this.chooseOrderId,
            startTime: this.useTime,
            autoRenewal: this.autoRenewal,
          }
          this.$ajax(this.$url.effectiveOrder(), data, false)
            .then(res => {
              this.$message({
                message: $t('操作成功'),
                type: 'success',
              })
              this.getList()
              this.changeTimeDialog = false
              this.disabledBool = false
            })
            .catch(err => {
              this.changeTimeDialog = false
              this.$alert(err.message, $t('提示'), {
                confirmButtonText: $t('确定'),
                type: 'error',
                dangerouslyUseHTMLString: true,
                showClose: false,
              })
              this.disabledBool = false
            })
        })
        .catch(() => {})
        .finally(() => {
            this.disabledBool = false
          })
      },

    showChildService({ id, commodityName }) {
      this.orderId = id
      this.step = 1
      this.commodityName = commodityName
      this.basicOpenServerData = []
      this.checkOpenServerData = []
      this.$ajax(this.$url.getOrderChilds(id), {
        showDetail: true,
      }).then(res => {
        this.basicOpenServerData = res.data || []
        this.openServerDialog = true
      })
    },
    // 数组去重复
    arrDistinct(array, key) {
      const result = []
      const obj = {}
      for (let index = 0; index < array.length; index++) {
        if (!obj[array[index][key]]) {
          result.push(array[index])
          obj[array[index][key]] = true
        }
      }

      return result
    },
    openChilds: debounce(
      function openChilds() {
        this.$ajax(this.$url.openChilds(this.orderId), this.arrDistinct(this.checkOpenServerData, 'id')).then(res => {
          this.openServerDialog = false
          this.$alert($t('您已开通新的认证服务项，即刻可以使用！'), $t('认证服务开通成功'), {
            confirmButtonText: $t('确定'),
          })
        })
      },
      debounceTime,
      true
    ),

    listToTree(jsonData) {
      const treeData = []
      // 过滤 价格为0 且充值子项允许0元计费的产品
      const modifiedA = jsonData
        .filter(item => item.price !== 0)
        .map(item => {
          /* i18n-ignore */
          if (item.tagName === '充值子项允许0元计费') {
            item.tagName = '其他'
          }

          return item
        })

      // 把modifiedA按tagName分类
      const groupedA = modifiedA.reduce((acc, item) => {
        if (!acc[item.tagName]) {
          acc[item.tagName] = []
        }
        if (!acc[item.tagName].find(node => node.name === item.name)) {
          acc[item.tagName].push(item)
        }

        return acc
      }, {})
      // 分类后扁平化，按照tree的数据格式组装

      Object.entries(groupedA)
        .map(([tagName, items]) => {
          const rowspan = items.length
          const firstItem = { ...items[0], rowspan }

          return [firstItem, ...items.slice(1)]
        })
        .flat()
        .forEach(item => {
          if (treeData.some(treeItem => treeItem.tagName === item.tagName)) {
            treeData[treeData.length - 1].child.push(item)
          } else {
            treeData.push({
              ...item,
              child: [item],
            })
          }
        })

      return treeData
    },
    getDetail({ id }) {
      this.treeData = []
      this.$ajax(this.$url.getOrderChilds(id), {}).then(res => {
        this.treeData = this.listToTree(res.data) || []
      })
    },
    changeCheckList(arr) {
      this.checkOpenServerData = this.arrDistinct(arr, 'id')
    },
    nextStep() {
      if (this.checkOpenServerData.length === 0) {
        this.$message.error($t('请选择服务名称'))

        return
      }
      this.step = 2
    },
    PreviousStep() {
      this.step = 1
    },
    isToday(str) {
      return str > 1549074951000
    },
    isCanResaleStatusOrder(item) {
      // 订单可以转售的状态
      const showCanResaleList = ['生效中', '交易成功']

      return showCanResaleList.includes(item.webParameter.status)
    },
    isCanResaleOrder(item) {
      return !(item.margin === 0 || !this.isCanResaleStatusOrder(item))
    },
    isProductOrder(item) {
      // 产品类订单
      const productOrderList = [2, 11, -2]

      return productOrderList.includes(item.productType)
    },
    isResaleMainOrder(item) {
      // 转售主订单
      const resaleMainOrderList = [10, 11]

      return resaleMainOrderList.includes(item.productType)
    },
    isResaleSubOrder(item) {
      const resaleSubOrderList = [-1, -2]

      return resaleSubOrderList.includes(item.productType)
    },
    downLoad(item) {
      this.$ajax(this.$url.licenseDownload(item.id), {}).then(res => {
        window.open(res.data.downUrl)
      })
    },
    // 再次购买按钮
    showBuyButton(item) {
      return (
        item.webParameter.showBuyAgain === 1 &&
        !this.isPartner &&
        this.commodityList.some(comItem => comItem.commodityId === item.commodityId) // 指定橱窗
      )
    },
    // 历史授权
    showHistoryAuthButton(item) {
      return item.authorizedStatus === 0 && item.orderType === 3 && !this.isResaleMainOrder(item) && this.userInfo.isAdmin
    },
    // 我要开票按钮
    showInvoiceButton(item) {
      return item.webParameter.invoiceOperatorFlag === 1 && this.activeName === 0
    },
    // 在线支付按钮
    showPayButton(item) {
      return item.webParameter.isShowPayFlag === 1 && this.activeName === 0
    },
    async getShowCaseCommodity() {
      this.firstReqTime = Date.now()

      return this.$ajax(this.$url.getShowCaseCommodity('buy002'), {}).then(res => {
        this.commodityList = res.data || []
        this.commodityList = this.commodityList.filter(item => item.showcaseCommodityStatus === 1)
      })
    },
    // 操作转售、授权、历史授权
    orderAuthRuleCheck(item, type, isResale, orderType) {
      if (!this.isCanResaleOrder(item) && isResale) {
        return
      }
      tsignData.track('PC_bill_click', { buttonName: 'authorization' })
      this.$router.push({
        path: '/empower',
        query: {
          authOrderId: item.id,
          type,
          isResale,
          orderType,
        },
      })
    },
    // 被授权订单
    orderAuthQuery(item) {
      const data = {
        authOrderId: item.id,
      }
      this.$ajax(this.$url.orderAuthQuery(), data).then(res => {
        this.$set(item, 'authGidName', res.data.authGidName || '')
        this.$set(item, 'authTime', formatUtc(res.data.authTime) || '')
      })
    },
    // 我要开票
    jumpInvoice(item) {
      window.sessionStorage.orderList = JSON.stringify([item])
      this.$router.push({
        path: '/MyOrder/invoice',
        query: {
          type: 1,
        },
      })
    },

    getOrderListCanInvoiced() {
      return this.orderList.filter(item => {
        return this.showInvoiceButton(item)
      })
    },

    // 合并开票
    combinedInvoice() {
      if (!this.getOrderListCanInvoiced().length) {
        this.$message.error('本页无可开票的订单！')

        return
      }

      if (!this.showCheckBox) {
        this.showCheckBox = true

        return
      }
      if (this.checkList.length === 0) {
        this.$message.error($t('请选择订单'))

        return
      }
      const companyCode = this.checkList[0].companyCode
      let obj = this.checkList.find(item => item.companyCode !== companyCode)
      if (obj) return this.$message.error($t('非同一主体的企业或个人不能合并开票'))

      window.sessionStorage.orderList = JSON.stringify(this.checkList)
      this.$router.push({
        path: '/MyOrder/invoice',
      })
    },
    // 查看历史结算
    showHistory(orderItem) {
      this.historyProductType = orderItem.productType
      this.dialogVisible = true
      this.tableData = orderItem.volumesList || []
      this.tableData.forEach(item => {
        item.startToEnd = `${formatUtc(item.produceStartTime, 'month')}`
        item.costMoney = item.produceCost
        item.hasPay = item.amountPaid
        item.noPay = (item.produceCost - item.amountPaid).toFixed(2)
      })
    },
    // 我的订单 tab切换
    changeActive(val) {
      this.activeName = val
      this.currentPage = 1
      // 赠送订单和被授权订单不展示搜索条件
      if (this.activeName === 1 || this.activeName === 2 || this.activeName === 3) {
        this.search.productTypes = ''
        this.search.isAuthOrder = ''
      }
      switch (val) {
        case 0:
          this.getOrderList()
          break
        case 1:
          // this.getOrderList()
          break
        case 2:
          // 授权订单-普通
          this.getAuthorizedOrderList()
          break
        case 3:
          // 授权订单-其他
          this.getAuthorizedOrderList()
          break
        default:
          this.getOrderList()
          break
      }
    },
    async jumpDetail(item, type) {
      if (type === $t('再次购买')) {
        this.$router.push({
          path: '/MyOrder/comfirm',
          query: {
            commodityId: item.commodityId,
            menuId: item.saleInfoId,
            type: item.saleType,
          },
        })
      } else if (type === $t('查看账单')) {
        /* i18n-ignore */
        if (item.showState === '待生效' || item.used === 0) {
          return
        }
        const year = new Date().getFullYear()
        const month = new Date().getMonth() + 1
        this.$router.push({
          path: '/BillDetail',
          query: {
            proId: item.productId,
            year,
            month,
            orderId: item.id,
            isPartner: this.isPartner,
          },
        })
      } else if (type === $t('在线支付')) {
        await this.checkPriceAdjusting(item)
        this.$reportBusiness('business_monitor_event_start', 'order_pay', {
          appId: this.$route.query.appid,
          ouid: this.userInfo.gid,
          orgId: this.userInfo.orgId,
          orderId: item.id,
          stage: 'OrderConfirm',
        })
        this.$router.push({
          path: '/RechargeOnline',
          query: {
            orderId: item.id,
          },
        })
      } else if (type === $t('物流信息')) {
        this.$router.push({
          path: '/deliveryMage',
          query: {
            orderId: item.id,
            proId: item.productId,
          },
        })
      } else if (type === $t('我要开票')) {
        await this.checkPriceAdjusting(item)
        this.jumpInvoice(item)
      } else if (type === $t('查看发票')) {
        this.getEleInfo(item.id)
      } else if (type === $t('转售记录')) {
        this.$router.push({
          path: '/resellRecord',
          query: {
            orderId: item.id,
            proId: item.productId,
            isResell: 1,
          },
        })
      } else if (type === $t('授权记录')) {
        this.$router.push({
          path: '/resellRecord',
          query: {
            orderId: item.showId,
            proId: item.productId,
            isResell: 0,
            gid: item.gid,
            disableCheckDebit: item.webParameter.showBillDetail === 2,
            disableJump: item.showState === '待生效' || item.used === 0,
          },
        })
      }
    },
    // 转售记录
    getEleInfo(id) {
      const oid = this.userInfo.orgId ? this.userInfo.orgId : this.ouid
      this.$ajax(this.$url.elecInvoicedetail(id, oid)).then(res => {
        if (res.code === 20502002) {
          this.$message.error(res.message)
          this.$router.push('/Myorder')
        } else if (res.data.invoiceStatus === 2) {
          this.$message({
            type: 'warning',
            message: $t('发票审核中'),
          })
        } else if (res.data.invoiceStatus === 5) {
          this.$router.push({
            path: '/ElecInvoice',
            query: {
              orderId: id,
            },
          })
        } else if (res.data.invoiceStatus === 3) {
          this.$message({
            type: 'warning',
            message: $t('开票中，请稍后'),
          })
        } else {
          this.$message({
            type: 'warning',
            message: $t('开票系统维护中，请稍后再试'),
          })
        }
      })
    },
    searchList() {
      this.currentPage = 1
      this.getList()
    },
    clear() {
      this.search = {
        status: '',
        time: '',
        proId: '',
        productTypes: '',
        isAuthOrder: '',
        payStatus: '',
      }
      this.getList()
    },
    currentChange(val) {
      this.currentPage = val
      this.getList()
    },
    async getproList() {
      return this.$ajax(this.$url.getCommoditysList(), {}).then(res => {
        this.proList = res.data.filter(item => item != null)
      })
    },
    async getOrderList(initReq = false) {
      let data = {}
      if (this.$route.query.payOrderId) {
        data = {
          payOrderId: this.$route.query.payOrderId,
        }
      } else {
        if (this.$route.query.channelGid) {
          sessionStorage.setItem('channelGid', this.$route.query.channelGid)
        }
        data = {
          productTypes: this.search.productTypes === '0' ? [10, 11] : [],
          isAuthOrder: this.search.productTypes === '1' ? 1 : '',
          status: this.search.status,
          createTimeStart: this.search.time && this.search.time.length > 0 ? this.search.time[0] : '',
          createTimeEnd: this.search.time && this.search.time.length > 0 ? this.search.time[1] + 24 * 60 * 60 * 1000 : '',
          commodityId: this.search.proId,
          currentPage: this.currentPage,
          orderType: 0,
          paymentType: this.search.productTypes === '3' ? 3 : '', // 后付费订单传3
          payStatus: this.search.payStatus,
          channelGid: this.$route.query.channelGid || sessionStorage.getItem('isPartner') ? sessionStorage.getItem('channelGid') : '', // ep读取channelGid查询
          confirmStatus: this.search.status === 1 ? true : '',
          contractId: this.search.contractId,
          showId: this.search.showId,
        }
      }
      this.$ajax(this.isOrg ? this.$url.getOrganizeOrderList() : this.$url.getPersonOrderList(), data)
        .then(res => {
          this.showCheckBox = false
          this.resolueRes(res)
          this.showView = true
          initReq && this.reportShenCeData(Date.now())
        })
        .catch(() => {
          this.showView = true
        })
    },
    resolueRes(res) {
      this.orderList = res.data || []
      if (this.activeName === 3) {
        this.orderList.map(item => {
          if (item.activeType === 'TYING') {
            item.showType = $t('搭售')
          } else if (item.approvalType === 2) {
            item.showType = $t('售后赔偿')
          } else {
            item.showType = item.giftType === 2 ? $t('增加时长') : item.giftChannel === 1 ? $t('试用') : $t('免费数量')
          }
          item.startToEnd = item.productType === 2 ? '--' : `${formatUtc(item.startTime, 'day')} - ${formatUtc(item.endTime, 'day')}`
          item.showSendNumber =
            item.giftType === 1 && item.isUnLimitNum
              ? $t('无限')
              : item.units === 'G'
              ? showDataUnit(item.totalNum, 'floor', item)
              : getShowPrice(item, 'totalNum', 'G') + getShowUnit(item)
          item.showState = item.webParameter.status

          if (item.status !== 0 && item.status !== 6) {
            if (item.giftType === 1) {
              // 订单数量
              item.sendMargin = item.giftType === 1 && item.isUnLimitNum ? $t('无限') : getShowPrice(item, 'margin', 'G')
            } else {
              // 赠送时长
              if (+new Date() < item.startTime) {
                item.margin = item.totalNum
              } else if (+new Date() > item.endTime) {
                item.margin = 0
              } else {
                item.margin = parseInt((item.endTime - +new Date()) / (60 * 60 * 24 * 1000)) + 1
              }
              item.sendMargin = item.margin
            }
            item.showUserd =
              item.giftType === 1
                ? item.units === 'G'
                  ? showDataUnit(item.used, 'floor', item)
                  : getShowPrice(item, 'used', 'KB', 1) + getShowUnit(item, 'KB', 1, 'used')
                : $t('{slot1}天', { slot1: item.totalNum - item.margin })

            item.showSendMargin =
              item.giftType === 1 && item.isUnLimitNum
                ? $t('无限')
                : item.units === 'G'
                ? showDataUnit(item.margin, 'ceil', item)
                : item.sendMargin + getShowUnit(item, 'G')
          }
        })
      }
      this.allNumber = res.rowCount || 0
      this.orderList.forEach(item => {
        if (item.paymentType === 3) {
          this.getVolumes(item.id, item)
        }
        item.logisticInfo = []
        item.totalNum = getShowPrice(item, 'totalNum', 'G')
        // 转换已使用量单位
        item.usedUnits = getShowUnit(item, 'KB', 1, 'used')
        // item.used = getShowPrice(item, 'used', 'KB', 1)
        // item.margin = getShowPrice(item, 'margin', 'G', 2)
        // 状态逻辑
        item.showState = item.webParameter.status
        if (![0, 6].includes(item.status)) {
          item.startToEnd = this.isProductOrder(item)
            ? '--'
            : `${formatUtc(item.startTime, 'day')} - ${item.isUnLimitTime ? $t('无限') : formatUtc(item.endTime, 'day')}`
        } else {
          item.startToEnd = '-'
        }
      })
    },
    getAuthorizedOrderList(initReq = false) {
      this.loading = true
      // 第一次请求
      const data = {
        createTimeStart: this.search.time && this.search.time.length > 0 ? this.search.time[0] : '',
        createTimeEnd: this.search.time && this.search.time.length > 0 ? this.search.time[1] + 24 * 60 * 60 * 1000 : '',
        commodityId: this.search.proId,
        currentPage: this.currentPage,
        status: this.search.status,
      }
      if (this.activeName === 3) {
        data.orderType = 1
      }
      this.$ajax(this.$url.getAuthorizedOrderList(), data).then(res => {
        this.resolueRes(res)
        initReq && this.reportShenCeData(Date.now())
      })
    },
    getVolumes(order, item) {
      this.$ajax(this.$url.volumes(order)).then(res => {
        if (res.data.length > 0) {
          this.$set(item, 'volumesList', res.data)
        }
      })
    },
    async getList(initReq = false) {
      switch (this.activeName) {
        case 0:
          this.getOrderList(initReq)
          break
        // 赠送
        case 1:
          this.$refs.myPresent.getGiftList()
          break
        // 被授权-普通
        case 2:
          this.getAuthorizedOrderList(initReq)
          break
        // 被授权-其他
        case 3:
          this.getAuthorizedOrderList(initReq)
          break
        default:
          this.getOrderList(initReq)
          break
      }
    },
    // 查看是否有解约函
    getHasRescindContract() {
      this.$ajax(this.$url.hasRescindContract(), {}).then(res => {
        this.hasRescindContract = res.data
      })
    },
    // 客户查看解约函详情
    getViewRescindContractFile() {
      return this.$ajax(this.$url.viewRescindContractFile(), {}, false).then(res => {
        const { data } = res
        if (data.length) {
          this.protocol = data[0].downloadUrl
          this.contractId = data[0].contractId
        }

        return data
      })
    },
    // 查看详情
    getPdfUrl() {
      this.pdfVisible = true
    },
    // 客户是否同意解约
    setAccountAffirmRescindContract: debounce(
      function setAccountAffirmRescindContract(agreeToRescind) {
        const data = {
          contractId: this.contractId,
          agreeToRescind, // 0-否; 1-是
        }
        this.RescindContractStatus = true
        this.$ajax(this.$url.accountAffirmRescindContract(), data).then(res => {
          this.pdfVisible = false
          this.showTip = false
          this.RescindContractStatus = false
          this.$message({
            message: $t('操作成功'),
            type: 'success',
          })
          if (this.taskResult[1] && this.canShowNextDialog) {
            this.taskResult[1]()
            this.canShowNextDialog = false
          }
        })
      },
      debounceTime,
      true
    ),

    // 查看结算单详情
    getViewContractBillFile() {
      return this.$ajax(this.$url.viewContractBillFile(), {}, false).then(res => {
        const { data } = res
        if (data.length) {
          this.billProtocol = data[0].downloadUrl
          this.billcontractId = data[0].contractId
        }

        return data
      })
    },
    accountAffirmTerminationContract: debounce(
      // 确认结算单
      function accountAffirmTerminationContract() {
        this.$ajax(this.$url.accountAffirmTerminationContract(), {
          contractId: this.billcontractId,
        }).then(res => {
          this.showBillTip = false
          this.billPdfVisible = false
          this.downLoadBillFile()
          if (this.taskResult[1] && this.canShowNextDialog) {
            this.taskResult[1]()
            this.canShowNextDialog = false
          }
        })
      },
      debounceTime,
      true
    ),

    downLoadBillFile() {
      const axiosHttp = axios.create()
      axiosHttp.defaults.withCredentials = false

      axiosHttp
        .get(`${this.billProtocol}`, {
          responseType: 'blob',
        })
        .then(res => {
          const fileName = $t('结算单-{slot1}.pdf', { slot1: this.billcontractId }) // 指定下载文件名
          // 兼容IE
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(res.data, fileName)
          } else {
            const blob = res.data
            const href = URL.createObjectURL(blob) // 创建新的URL表示指定的blob对象
            const a = document.createElement('a') // 创建a标签
            a.style.display = 'none'
            a.href = href // 指定下载链接
            a.download = fileName
            a.click() // 触发下载
            URL.revokeObjectURL(a.href) // 释放URL对象
          }
        })
    },
    getBillPdfUrl() {
      this.billPdfVisible = true
    },
    hasLength() {
      const result = []
      const contractListShow = () => {
        // 显示解约单
        this.showTip = true
        this.pdfVisible = true
      }
      const contractBillsShow = () => {
        // 显示结算单
        this.showBillTip = true
        this.billPdfVisible = true
      }

      // 解约单&&结算单都存在 按修改时间顺序 优先暂时最近修改的
      if (this.contractList.length && this.contractBills.length) {
        if (this.contractList[0].modifyDate > this.contractBills[0].modifyDate) {
          result.push(contractListShow)
          result.push(contractBillsShow)
        } else {
          result.push(contractBillsShow)
          result.push(contractListShow)
        }
      } else {
        if (this.contractList.length) {
          result.push(contractListShow)
        }

        if (this.contractBills.length) {
          result.push(contractBillsShow)
        }
      }

      return result
    },
    // 查询订单是否在改价中
    async checkPriceAdjusting(item) {
      try {
        const { data } = await this.$ajax(this.$url.checkPriceAdjusting(item.id))
        if (data) {
          this.$message.error($t('账单修改中，不支持操作'))

          return new Promise(() => {})
        }
      } catch (_) {}
    },
    // 上报神策埋点
    reportShenCeData(lastResTime) {
      const dataObj = getTimingData($t('我的订单'))
      const reqDataObj = {
        businessData_load_time: lastResTime - this.firstReqTime,
        time_consume: lastResTime - window.performance.timing.fetchStart,
      }
      tsignData.track('front_init_time_consume', { ...dataObj, ...reqDataObj })
    },
    // 判断是否有更多操作按钮需要显示
    hasMoreOperations(item) {
      return (
        (item.webParameter.canOperateResale !== 0 && this.userInfo.isAdmin) ||
        item.webParameter.showBillDetail !== 0 ||
        (item.webParameter.isShowResaleHis === 1 && this.activeName == 0 && this.userInfo.isAdmin) ||
        item.webParameter.isShowElecInvoiceFlag ||
        item.webParameter.showChildServiceOpenFlag === 1 ||
        this.showBuyButton(item) ||
        item.webParameter.showSettlementRecordFlag !== 0 ||
        item.webParameter.isShowAuth === 1 ||
        item.webParameter.isAuthOrder === 1 ||
        item.webParameter.isDeliver === 1
      )
    },
    // 处理下拉菜单操作
    handleCommand(command, item) {
      switch (command) {
        case 'operateResale':
          this.orderAuthRuleCheck(item, 'MyOrder', '1')
          break
        case 'viewBill':
          this.jumpDetail(item, $t('查看账单'))
          break
        case 'resaleRecord':
          this.jumpDetail(item, $t('转售记录'))
          break
        case 'viewInvoice':
          this.jumpDetail(item, $t('查看发票'))
          break
        case 'openChildService':
          this.showChildService(item)
          break
        case 'buyAgain':
          this.jumpDetail(item, $t('再次购买'))
          break
        case 'viewSettlementHistory':
          this.showHistory(item)
          break
        case 'authorize':
          this.orderAuthRuleCheck(item, 'MyOrder', '', 0)
          break
        case 'authRecord':
          this.jumpDetail(item, $t('授权记录'))
          break
        case 'logistics':
          this.jumpDetail(item, $t('物流信息'))
          break
        default:
      }
    },
  },
  async mounted() {
    this.ouid = localStorage.getItem('ouid')
    this.getShowCaseCommodity()
    this.getproList()
    this.getList(true)
    this.getTab()
    Promise.all([this.getViewContractBillFile(), this.getViewRescindContractFile()]).then(res => {
      this.contractBills = res[0]
      this.contractList = res[1]
      this.taskResult = this.hasLength()
      if (this.taskResult[0]) this.taskResult[0]()
    })
  },
}
</script>
<style lang="less">
.effective-order {
  z-index: 2030 !important;
  .es-message-box__content {
    padding: 0;
  }
}
</style>
<style lang="less" scoped>
#myOrder {
  font-size: 14px;
}
.search-section {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  padding: 0 24px;
  min-height: 64px;
  div {
    // height: 30px;
    margin-bottom: 10px;
    margin-right: 10px;
  }
}
.allNumber {
  flex: 1;
  text-align: right;
  margin-right: 0;
  min-width: 126px;
}
.es-icon-circle-check {
  font-size: 15px;
}
.protocol {
  height: 500px;
  margin-bottom: 30px;
  overflow: auto;
}
.confirm-time {
  margin-top: 24px;
}
.changeTime {
  .changeTime-tip {
    color: #ffb03c;
    margin-bottom: 20px;
    .changeTime-tip-gap {
      margin-bottom: 5px;
    }
  }
}

.authTip {
  background: #88acdc;
  color: #fff;
  border-radius: 10px;
  padding: 0 10px;
  cursor: pointer;
}
.hasCheck {
  color: #1875f0;
}

.marginLeft0 {
  margin-left: 0 !important;
  min-width: 120px !important;
}

/deep/ .es-pagination {
  height: 30px;
  margin: 12px 0 !important;
  padding-right: 200px;
}
.main {
  padding-bottom: 80px;
}

.wd-80 {
  width: 80px;
}

.footer {
  z-index: 1000;
  background: #fff;
  height: 54px;
  line-height: 54px;
  position: fixed;
  bottom: 0;
  width: 100%;
  min-width: 1100px;
  box-shadow: 0 -1px 2px 0 rgba(0, 0, 0, 0.1);
  > div {
    justify-content: space-between;
    display: flex;
    padding: 0 24px;
  }
}
.tabs {
  display: flex;
  margin: 10px 24px;
  border-bottom: 1px solid #00000017;
  > li {
    cursor: pointer;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: #000000a6;
    height: 40px;
    line-height: 40px;
    width: auto;
    padding: 0 8px;
    margin-right: 24px;
  }
  li.active {
    border-bottom: 2px solid #1063f1;
    color: #1063f1;
    font-weight: 600;
  }
  li:hover {
    color: #1063f1;
  }
}
.es-icon-question {
  cursor: pointer;
}
.background245 {
  background: RGBA(245, 245, 245, 1) !important;
}

.icon-stop {
  background-image: url('../../assets/icons/stop.svg');
  width: 13px;
  height: 13px;
  background-size: cover;
  display: inline-block;
  vertical-align: middle;
}
.detailTip {
  text-align: center;
  color: RGBA(102, 102, 102, 1);
}
.readyIcon {
  width: 15px;
  height: 14px;
  background-image: url('../../assets/use/ready.png');
  background-size: cover;
  display: inline-block;
  vertical-align: sub;
}

.ready {
  color: #1890ff !important;
}
.success {
  color: RGBA(5, 199, 5, 1) !important;
}
.unsuccess {
  color: RGBA(179, 179, 179, 1) !important;
}
.stop {
  color: RGBA(250, 173, 20) !important;
}

.small-tip {
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fef6e9;
  border-radius: 4px;
  border: 1px solid rgba(252, 236, 211, 1);
  height: 48px;
  margin: 5px 0;
  width: 700px;
  color: #f0a225;
  position: absolute;
  left: 50%;
  margin-left: -350px;
}
.confirm-bill-confirm {
  text-align: right;
  cursor: pointer;
  font-size: 14px;
  color: rgba(153, 153, 153, 1);
  div:first-child {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.dialog-title {
  font-size: 20px;
  span {
    color: #909399;
    font-size: 14px;
  }
}
.table-card-header {
  height: 80px;
  background: #f7f8fa;
  display: flex;
  margin-top: 20px;
  box-shadow: 0px 1px 0px 0px #e4e4e4;
  justify-content: space-between;
  padding: 0 30px;
  border: 1px solid #e4e4e4;
  border-bottom: none;
  .table-card-header-name {
    position: relative;
    .table-card-header-checkbox {
      position: absolute;
      left: -20px;
    }
  }
  > div {
    padding-top: 15px;
    display: flex;
    flex-direction: column;
    > div:first-child {
      margin-bottom: 10px;
      color: #232323ff;
      font-weight: 600;
    }
    div:last-child {
      color: #1a1a1aff;
    }
  }
}
.table-title,
.table-main {
  height: 50px;
  line-height: 50px;
  border: 1px solid #e4e4e4ff;
  border-top: none;
  color: #999999;
  padding-left: 30px;
}
.table-main {
  color: #4b4b4bff;
}
.table-card {
  box-shadow: 0px 0px 6px 0px #dce0ef;
  margin: 0 24px;
}
.info-header {
  height: 30px;
}
.table-diabled {
  .table-card-header {
    border-bottom: 1px solid #e4e4e4;

    > div {
      > div {
        color: #999999 !important;
      }
    }
  }
  .table {
    .table-main {
      color: #999999 !important;
    }
    background: #f7f8fa !important;
  }
}
.width-auto {
  width: auto;
}
/deep/ .es-empty__image {
  width: 64px;
}
.operation-buttons {
  white-space: nowrap;
  overflow: hidden;
  height: 50px;
  line-height: 50px;

  .es-button {
    margin-right: 8px;
  }
}
</style>
